module.exports = __webpack_public_path__ + "static/gm-27-bd9c61e3719405bd3435e944c75afe70.jpg";